const STORAGE_KEY = 'lockScreenLastActivity';
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'touchmove', 'scroll', 'click'];

class ActivityTracker {
    constructor() {
        this.lastActivity = Date.now();
        this.subscribers = new Set();
        this.paused = false;
        this.boundHandler = this.onActivity.bind(this);
        this.boundStorage = this.onStorage.bind(this);
        this.installed = false;
    }

    install() {
        if (this.installed || typeof window === 'undefined') return;
        EVENTS.forEach(ev => window.addEventListener(ev, this.boundHandler, { passive: true }));
        window.addEventListener('storage', this.boundStorage);
        this.installed = true;
    }

    uninstall() {
        if (!this.installed || typeof window === 'undefined') return;
        EVENTS.forEach(ev => window.removeEventListener(ev, this.boundHandler));
        window.removeEventListener('storage', this.boundStorage);
        this.installed = false;
    }

    onActivity() {
        if (this.paused) return;
        const now = Date.now();
        this.lastActivity = now;
        try {
            localStorage.setItem(STORAGE_KEY, String(now));
        } catch (err) {
            // localStorage might be full / disabled — ignore
        }
        this.notify(now);
    }

    onStorage(e) {
        if (e.key !== STORAGE_KEY || !e.newValue) return;
        const value = parseInt(e.newValue, 10);
        if (Number.isFinite(value) && value > this.lastActivity) {
            this.lastActivity = value;
            this.notify(value);
        }
    }

    pause() {
        this.paused = true;
    }

    resume() {
        this.paused = false;
        this.onActivity();
    }

    getLastActivity() {
        return this.lastActivity;
    }

    subscribe(fn) {
        this.subscribers.add(fn);
        return () => this.subscribers.delete(fn);
    }

    notify(value) {
        this.subscribers.forEach(fn => {
            try {
                fn(value);
            } catch (err) {
                console.warn('activityTracker subscriber threw', err);
            }
        });
    }
}

const activityTracker = new ActivityTracker();
export default activityTracker;
export { STORAGE_KEY, EVENTS };
